import {LocaleMessages} from "vue-i18n";
import {h} from "vue";

export const lang_tid:LocaleMessages<any> = {
    en: {
        menu: 'Menu',
        community:'Community',
        join_community:"Join Community",
        change_log:"Change Log",
        download:'Download',
        news:'News',
        qq_group:"QQ Group {index}",
        qq_channel:"QQ Channel",
        discord:"Discord",
        join:'Join',
        telegram:"Telegram",
        github:"GitHub",
        google_drive:"Google Drive",
        one_drive:"One Drive",
        android:"Android",
        ios:"IOS",
        add_qun_download:"Download in Groups",
        rain_yun:`<div class="support-box">
<h2>❤️ Support Us</h2>
<p>To support the development of CM:Reborn, we need your help.</p>
<p>Your small donation will help us maintain servers, continue development, and improve the overall experience.</p>
<p style="color: yellow">Supporters can receive some rewards.</p>
<p>
  You can support us via 
  <a href="https://ko-fi.com/cmr" target="_blank" style="color: #fdcf17">☕️ Ko-fi</a>
  or 
  <a href="https://www.patreon.com/cmreborn" target="_blank" style="color: #fdcf17">🎁 Patreon</a>
</p>
</div>`,
        close:"Close",
        news_content: `
      <h2>Update Released!</h2>
      <div class="version-info">
        <strong>CMREBORN v1.2.0</strong><br>
        <span>Release Notes - March 2026</span>
      </div>

      <div class="section">
        <h3>2 New Minis:</h3>
        <ul>
          <li><strong>Librarian</strong> - 3 Elixir [Specialist]<br>A ranged summoner whose pet, Nibbles, marks enemies, making them take extra damage.</li>
          <li><strong>Gunner Goblin</strong> - 3 Elixir [Goblin Rider]<br>A powerful ranged rider who constantly buffs himself with his Super and unleashes a stunt goblin to aid in combat upon defeat.</li>
        </ul>
      </div>

      <div class="section">
        <h3>New Trait:</h3>
        <p class="trait-name">Fire</p>
        <ul>
          <li>[2] When the team defeats an enemy, Fire deals 2 extra damage for 4 seconds.</li>
          <li>[4] Upon being defeated, the team explodes dealing 7 damage.</li>
          <li>Units joining this trait: Firecracker, Lava Golem, Hot Pot, Wizard, and Inferno Tower</li>
        </ul>
      </div>

      <div class="section">
        <h3>New Skins:</h3>
        <ul>
          <li>Valentine's Grand Warden</li>
          <li>Valentine's Lumberjack</li>
          <li>Love Potion Elixir Golem</li>
          <li>Gummy Bear Elixir Golem</li>
          <li>Goo-eye Elixir Golem</li>
          <li>Baker Royal Champion</li>
          <li>Jeff Magic Archer</li>
          <li>Platinum Barbarian King</li>
          <li>Golden Barbarian King</li>
          <li>Dark Elixir Pump</li>
        </ul>
      </div>

      <div class="section">
        <h3>Other Additions:</h3>
        <ul>
          <li>Special events can now be found in the events tab, the first event starts in <strong>3 days!</strong></li>
          <li>Text emotes can now be used in combat!</li>
          <li>Name change feature has been fixed</li>
        </ul>
      </div>`,
      changelog_content: `
      <h2>Balance Changes:</h2>
      <div class="section">
        <h3>Heroes</h3>
        <ul>
          <li><strong>Lava Golem - Rework</strong>
            <ul>
              <li>Added Specialist and Fire</li>
              <li>Energy gained from each attack reduced to 1 (from 2)</li>
              <li>Max energy reduced to 6 (from 9)</li>
              <li>Base HP increased to 65 (from 60)</li>
              <li>Promotion HP bonus reduced to 15 (from 18)</li>
              <li>Lava Soldier's HP from Promotion 1 increased to 10 (from 6)</li>
              <li>ATK SPD boost from Promotion 2 increased to 100% (from 75%)</li>
              <li>Duration of Promotion 2 increased to 8s (from 6s)</li>
              <li>Upgrade 3's energy increase increased to +4 (from +3)</li>
            </ul>
          </li>
          <li><strong>Battle Machine - Buffs</strong>
            <ul>
              <li>Saint Mirror added to his Gizmo pool</li>
              <li>Base HP increased to 65 (from 60)</li>
              <li>Base ATK SPD increased to 1.3 (from 1.2)</li>
            </ul>
          </li>
          <li><strong>Royal Champion - Nerfs</strong>
            <ul>
              <li>Super DMG reduced to 12 (from 15)</li>
              <li>Base ATK SPD reduced to 1.2 (from 1.25)</li>
            </ul>
          </li>
          <li><strong>Natureborn - Nerf</strong>
            <ul>
              <li>Human form's ATK SPD reduced to 1.2 (from 1.25)</li>
            </ul>
          </li>
          <li><strong>Pink Fury - Nerf</strong>
            <ul>
              <li>Base HP reduced to 60 (from 65)</li>
            </ul>
          </li>
          <li><strong>Shield Maiden - Nerf</strong>
            <ul>
              <li>Base HP reduced to 75 (from 80)</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="section">
        <h3>Minis</h3>
        <ul>
          <li><strong>Potter - Rework</strong>
            <ul>
              <li>Upgrade 2 changed to PASSIVE! Add +3 DMG, increasing his min. to 6</li>
              <li>Upgrade 3 changed to After 4 hits, explode, dealing 20 DMG over 4 seconds (1/round)</li>
            </ul>
          </li>
          <li><strong>Firecracker - Rework</strong>
            <ul>
              <li>Clan class replaced with Fire</li>
              <li>Sparks DMG reduced to 2 (from 4)</li>
            </ul>
          </li>
          <li><strong>Witch - Rework</strong>
            <ul>
              <li>Clan class replaced with Mage</li>
              <li>Base ATK SPD Increased to 0.6 (from 0.5)</li>
            </ul>
          </li>
          <li><strong>Wizard - Rework</strong>
            <ul>
              <li>Clan class replaced with Fire</li>
              <li>Base ATK SPD increased to 0.8 (from 0.7)</li>
            </ul>
          </li>
          <li><strong>Dagger Goblin - Buff</strong>
            <ul>
              <li>Base ATK SPD increased to 0.6 (from 0.5)</li>
            </ul>
          </li>
          <li><strong>Defuser - Buff</strong>
            <ul>
              <li>Elixir from selling at 3 Stars increased to 12 (from 10)</li>
            </ul>
          </li>
          <li><strong>Valkyrie - Buff</strong>
            <ul>
              <li>Base ATK SPD increased to 0.6 (from 0.5)</li>
            </ul>
          </li>
          <li><strong>Bandit - Nerf</strong>
            <ul>
              <li>Energy steal from Upgrade 1 reduced to 2 (from 3)</li>
            </ul>
          </li>
          <li><strong>Elite Barbarian - Nerf</strong>
            <ul>
              <li>Base ATK SPD reduced to 0.8 (from 0.9)</li>
            </ul>
          </li>
          <li><strong>Prince - Nerf</strong>
            <ul>
              <li>DMG increase to his CLASH from Upgrade 1 reduced to 20 (from 24)</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="section">
        <h3>Classes</h3>
        <ul>
          <li><strong>Mage [4] - Buff</strong>
            <ul>
              <li>Energy given for every 2 Supers increased to 2 (from 1)</li>
            </ul>
          </li>
          <li><strong>Clan [2] - Nerf</strong>
            <ul>
              <li>ATK SPD bonus reduced to 5% (from 15%)</li>
            </ul>
          </li>
          <li><strong>Clan [4] - Nerf</strong>
            <ul>
              <li>ATK SPD bonus reduced to 10% (from 20%)</li>
            </ul>
          </li>
          <li><strong>Elixir [4] - Nerf</strong>
            <ul>
              <li>Elixir required to give Team +1 DMG increased to 6 (from 5)</li>
            </ul>
          </li>
          <li><strong>Ranger [4] - Nerf</strong>
            <ul>
              <li>ATK SPD bonus for Rangers reduced to 50% (from 60%)</li>
            </ul>
          </li>
          <li><strong>Saint [2] - Nerf</strong>
            <ul>
              <li>Healing and Shield boost reduced to 25% (from 30%)</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="section">
        <h3>Gizmos</h3>
        <ul>
          <li><strong>Pocket Artillery - Nerf</strong>
            <ul>
              <li>Stun duration reduced to 1s (from 2s)</li>
            </ul>
          </li>
          <li><strong>King Tower - Nerf</strong>
            <ul>
              <li>HP reduced to 55 (from 60)</li>
            </ul>
          </li>
        </ul>
      </div>`
    },
    zh: {
        menu: '主页',
        download:'下载',
        news:'新闻',
        community:'社区',
        change_log:"日志",
        join_community:"加入社区",
        qq_group:"Q群 {index}",
        qq_channel:"QQ频道",
        discord:"Discord",
        join:'加入',
        telegram:"电报",
        github:"GitHub",
        google_drive:"谷歌网盘",
        one_drive:"One Drive",
        android:"安卓",
        ios:"苹果",
        add_qun_download:"加群下载",
        rain_yun:`<div class="support-box">
    <div>❤️ 支持我们</div>
    <p>为了 CM:Reborn 的发展，我们需要你的支持。</p>
    <p>你的小小赞助，将帮助我们维持服务器、持续开发和优化体验。</p>
      <p>你可以通过 
      <a href="https://www.patreon.com/cmreborn" target="_blank" style="color: #fdcf17">🎁 Patreon</a>
      <a href="https://ko-fi.com/cmr" target="_blank" style="color: #fdcf17">☕️ Ko-fi</a>
      </p>
            <a href="/imageShow" target="_blank" style="color: #fdcf17">💚微信&amp;💙支付宝</a> 
      <p>进行赞助</p>
      <p style="color: yellow">支持者会获得一些奖励!</p>
    </div>`,
        close:"关闭",
        news_content: `
      <h2>更新发布!</h2>
      <div class="version-info">
        <strong>CMREBORN v1.2.0</strong><br>
        <span>发布说明 - 2026年3月</span>
      </div>

      <div class="section">
        <h3>2个新迷你英雄：</h3>
        <ul>
          <li><strong>图书管理员</strong> - 3费 [专家]<br>一个远程召唤师，它的宠物咬咬会给敌人标记，使其受到额外伤害。</li>
          <li><strong>炮手哥布林</strong> - 3费 [哥布林 骑手]<br>一个强大的远程骑手，他不断用超绝技强化自己，并在击败技时释放一个特技哥布林来帮助战斗。</li>
        </ul>
      </div>

      <div class="section">
        <h3>新羁绊：</h3>
        <p class="trait-name">火系</p>
        <ul>
          <li>[2] 当队伍击杀敌人时，火系造成额外2点伤害，持续4秒。</li>
          <li>[4] 被击杀时，队伍爆炸并造成7点伤害。</li>
          <li>加入该羁绊的单位：烟花炮手、熔岩戈仑、火锅侠、法师和狱塔护法</li>
        </ul>
      </div>

      <div class="section">
        <h3>新皮肤：</h3>
        <ul>
          <li>情人节圣锤战神</li>
          <li>情人节狂暴樵夫</li>
          <li>爱情魔药圣水机器人</li>
          <li>小熊软糖圣水格仑</li>
          <li>咕噜眼圣水机器人</li>
          <li>面包师飞盾战神</li>
          <li>杰夫幻术大师</li>
          <li>铂银蛮王</li>
          <li>辉金蛮王</li>
          <li>暗金重油收集器</li>
        </ul>
      </div>

      <div class="section">
        <h3>其他新增内容：</h3>
        <ul>
          <li>特殊活动现在可以在活动标签页中找到，第一个活动将在<strong>3天后开始！</strong></li>
          <li>战斗中可以使用文本表情！</li>
          <li>名字变更功能已修复</li>
        </ul>
      </div>`,
      changelog_content: `
      <h2>平衡性调整：</h2>
      <div class="section">
        <h3>英雄</h3>
        <ul>
          <li><strong>熔岩戈仑 - 重做</strong>
            <ul>
              <li>新增羁绊 专家、火焰</li>
              <li>每次攻击获得能量降低为 1（原为 2）</li>
              <li>最大能量降低为 6（原为 9）</li>
              <li>基础生命值提高到 65（原为 60）</li>
              <li>升星生命加成降低为 15（原为 18）</li>
              <li>一技能召唤的熔岩士兵生命提高到 10（原为 6）</li>
              <li>二技能攻速加成提高到 100%（原为 75%）</li>
              <li>二技能持续时间延长至 8 秒（原为 6 秒）</li>
              <li>三技能能量提升改为 +4（原为 +3）</li>
            </ul>
          </li>
          <li><strong>战争机器 - 加强</strong>
            <ul>
              <li>小发明池新增：圣镜</li>
              <li>基础生命值提高到 65（原为 60）</li>
              <li>基础攻速提高到 1.3（原为 1.2）</li>
            </ul>
          </li>
          <li><strong>飞盾战神 - 削弱</strong>
            <ul>
              <li>技能伤害降低到 12（原为 15）</li>
              <li>基础攻速降低到 1.2（原为 1.25）</li>
            </ul>
          </li>
          <li><strong>自然领主 - 削弱</strong>
            <ul>
              <li>人形态攻速降低到 1.2（原为 1.25）</li>
            </ul>
          </li>
          <li><strong>怒锤战神 - 削弱</strong>
            <ul>
              <li>基础生命值降低到 60（原为 65）</li>
            </ul>
          </li>
          <li><strong>圣盾女杰 - 削弱</strong>
            <ul>
              <li>基础生命值降低到 75（原为 80）</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="section">
        <h3>奇兵</h3>
        <ul>
          <li><strong>火锅侠 - 重做</strong>
            <ul>
              <li>二技能改为被动：+3 伤害，使最低伤害变为 6</li>
              <li>三技能改为：攻击 4 次后爆炸，在 4 秒内造成 20 伤害（每回合 1 次）</li>
            </ul>
          </li>
          <li><strong>烟花炮手 - 重做</strong>
            <ul>
              <li>羁绊改为火焰</li>
              <li>火花伤害降低到 2（原为 4）</li>
            </ul>
          </li>
          <li><strong>女巫 - 重做</strong>
            <ul>
              <li>羁绊改为法师</li>
              <li>基础攻速提高到 0.6（原为 0.5）</li>
            </ul>
          </li>
          <li><strong>法师 - 重做</strong>
            <ul>
              <li>羁绊改为火焰</li>
              <li>基础攻速提高到 0.8（原为 0.7）</li>
            </ul>
          </li>
          <li><strong>匕首哥布林 - 加强</strong>
            <ul>
              <li>基础攻速提高到 0.6（原为 0.5）</li>
            </ul>
          </li>
          <li><strong>圣水机器人 - 加强</strong>
            <ul>
              <li>三技能出售获得的圣水提高到 12（原为 10）</li>
            </ul>
          </li>
          <li><strong>女武神 - 加强</strong>
            <ul>
              <li>基础攻速提高到 0.6（原为 0.5）</li>
            </ul>
          </li>
          <li><strong>幻影刺客 - 削弱</strong>
            <ul>
              <li>一技能偷取能量降低到 2（原为 3）</li>
            </ul>
          </li>
          <li><strong>野蛮人精锐 - 削弱</strong>
            <ul>
              <li>基础攻速降低到 0.8（原为 0.9）</li>
            </ul>
          </li>
          <li><strong>王子 - 削弱</strong>
            <ul>
              <li>一技能冲锋伤害加成降低到 20（原为 24）</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="section">
        <h3>羁绊</h3>
        <ul>
          <li><strong>法师 [4] - 加强</strong>
            <ul>
              <li>每释放 2 次技能获得的能量提高到 2（原为 1）</li>
            </ul>
          </li>
          <li><strong>专家 [2] - 削弱</strong>
            <ul>
              <li>攻速加成降低到 5%（原为 15%）</li>
            </ul>
          </li>
          <li><strong>专家 [4] - 削弱</strong>
            <ul>
              <li>攻速加成降低到 10%（原为 20%）</li>
            </ul>
          </li>
          <li><strong>圣水 [4] - 削弱</strong>
            <ul>
              <li>提供全队 +1 伤害所需圣水提高到 6（原为 5）</li>
            </ul>
          </li>
          <li><strong>射手 [4] - 削弱</strong>
            <ul>
              <li>攻速加成降低到 50%（原为 60%）</li>
            </ul>
          </li>
          <li><strong>翼族 [2] - 削弱</strong>
            <ul>
              <li>治疗和护盾加成降低到 25%（原为 30%）</li>
            </ul>
          </li>
        </ul>
      </div>

      <div class="section">
        <h3>小发明</h3>
        <ul>
          <li><strong>袖珍火箭 - 削弱</strong>
            <ul>
              <li>眩晕时间降低到 1 秒（原为 2 秒）</li>
            </ul>
          </li>
          <li><strong>国王塔 - 削弱</strong>
            <ul>
              <li>生命值降低到 55（原为 60）</li>
            </ul>
          </li>
        </ul>
      </div>`
    }
}
